// extracted by mini-css-extract-plugin
module.exports = {"root":"ClientCreditCards_root__PUSns","cards":"ClientCreditCards_cards__2xzle","empty":"ClientCreditCards_empty__3IWHX"};